module.exports = __webpack_public_path__ + "img/main-screen-preview.13b7d0c6.png";